import React from 'react';
import { EmptyState } from 'src/components/Icons/EmptyStates';
import ToggleAllButton from '../ToggleAllButton';

class CardsTableLayout {
  constructor({ $id, headers, hasToolbar, itemsAreObjectType, itemsUiSchema, onEmptyMessage, positionButtons, props, rowClassNames }) {
    this.isTable = false;
    this.rowClassNames = rowClassNames;
    this.$id = $id;
    this.headers = headers;
    this.itemsAreObjectType = itemsAreObjectType;
    this.itemsUiSchema = itemsUiSchema;
    this.positionButtons = positionButtons;
    this.rowClassNames = rowClassNames;
    this.hasToolbar = hasToolbar;
    this.onEmptyMessage = onEmptyMessage;
    this.props = props;
  }

  wrapArray(children) {
    return <div className="array-cards">{children}</div>;
  }

  wrapBody(children) {
    return (
      <div className="array-item-list" key={`array-item-list-${this.$id}`}>
        {children}
      </div>
    );
  }

  wrapLoader(children) {
    return children;
  }

  wrapItem(id, props, onAddClick, rowIdx, rowCount, children, buttons, rowClassNames) {
    return (
      <div
        id={id}
        className={`has-buttons-position-${this.positionButtons || 'normal'} ${props.className} ${
          this.itemsAreObjectType ? 'for-object-row' : ''
        } ${rowClassNames}`}
      >
        <div>{children}</div>
        {buttons ? (
          <div className={`array-item-buttons col-xs-3 array-item-toolbox buttons-position-${this.positionButtons || 'normal'}`}>
            <div className="btn-group" style={{ display: 'flex', justifyContent: 'center' }}>
              {buttons}
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  wrapItemField({ name, uiSchema }, children) {
    return (
      <div key={name} className={(uiSchema[name] || {})['ui:cellClassName']}>
        {children}
      </div>
    );
  }

  wrapItemPanelRow(_1, children) {
    return <div className={`array-item panel-row ${this.rowClassNames}`}>{children}</div>;
  }

  wrapItemErrorList(children) {
    return <div>{children}</div>;
  }

  makeEmptyItemField({ name }) {
    return <td key={name} />;
  }

  makeSimpleItem(props) {
    return <div className={this.hasToolbar ? 'col-xs-9' : 'col-xs-12'}>{props.children}</div>;
  }

  wrapAddButton(children) {
    return <div>{children}</div>;
  }

  makeEmptyMessage() {
    return <EmptyState size={96} message={this.onEmptyMessage} />;
  }

  // Cards have no per-column header row to attach a select-all button to, so
  // instead render one small toolbar above the cards with a labelled toggle
  // button per column flagged `ui:includeToggleAll` (usually just one).
  makeHeaders() {
    const toggleHeaders = (this.headers || []).filter(h => h.toggleAll);
    if (!toggleHeaders.length) return null;

    return (
      <div className="array-cards-toolbar" style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
        {toggleHeaders.map(({ field, text }) => (
          <ToggleAllButton key={field} field={field} label={text || field} {...this.props} />
        ))}
      </div>
    );
  }
}

export default CardsTableLayout;
